import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './assets/images/logo.png'


const _hoisted_1 = { class: "content-common-width" }
const _hoisted_2 = { class: "logo-wrapper" }
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "143",
  height: "39"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]

import { ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'app',
  setup(__props) {

const officialUrl = ref(window.ENV_CONFIG.officialUrl);

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", null, [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("a", {
            href: officialUrl.value,
            target: "_blank"
          }, _hoisted_5, 8, _hoisted_3)
        ])
      ])
    ]),
    _createElementVNode("main", null, [
      _createVNode(_component_RouterView)
    ])
  ], 64))
}
}

})